var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-ad-section',{staticClass:"c-section c-section--leaderboard"})
}
var staticRenderFns = []

export { render, staticRenderFns }